(() => {
  function init(root) {
    if (!root || root.dataset.acReady) return;
    root.dataset.acReady = 'true';
    const variants = JSON.parse(root.querySelector('[data-ac-variants]').textContent);
    const format = JSON.parse(root.querySelector('[data-ac-money-format]').textContent);
    const qty = root.querySelector('[data-ac-qty]');
    const selector = root.querySelector('[data-ac-variant]');
    const radios = [...root.querySelectorAll('input[name="ac-pack"]')];
    const add = root.querySelector('[data-ac-add]');
    const offerSingular = root.dataset.acOfferSingular || 'unit';
    const offerPlural = root.dataset.acOfferPlural || 'units';
    const itemsPerOffer = Math.max(1, Number(root.dataset.acItemsPerOffer) || 1);
    const itemSingular = root.dataset.acItemSingular || 'item';
    const itemPlural = root.dataset.acItemPlural || 'items';
    const offerNote = root.dataset.acOfferNote || '';
    const offerNoteDouble = root.dataset.acOfferNoteDouble || '';
    const offerName = count => count === 1 ? offerSingular : offerPlural;
    const itemName = count => count === 1 ? itemSingular : itemPlural;
    const offerLabel = count => `${count} ${offerName(count)}${itemsPerOffer > 1 ? ` — ${count * itemsPerOffer} ${itemName(count * itemsPerOffer)}` : ''}`;
    const offerSubLabel = count => offerNote ? (count === 1 ? offerNote : (count === 2 && offerNoteDouble ? offerNoteDouble : `${count} × ${offerNote}`)) : (itemsPerOffer > 1 ? `${count * itemsPerOffer} ${itemName(count * itemsPerOffer)} included` : `${count} × selected option`);
    function money(cents) {
      const token = (format.match(/\{\{\s*(\w+)\s*\}\}/) || [,'amount'])[1];
      const noDecimals = token.includes('no_decimals');
      const comma = token.includes('comma_separator');
      const space = token.includes('space_separator');
      const apostrophe = token.includes('apostrophe_separator');
      const parts = (cents / 100).toFixed(noDecimals ? 0 : 2).split('.');
      const thousands = space ? ' ' : apostrophe ? "'" : comma ? '.' : ',';
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      const value = parts.join(comma || space ? ',' : '.');
      // The format originates from the merchant's Shopify money setting.
      return format.replace(/\{\{\s*\w+\s*\}\}/, value);
    }
    const galleryPanels = [...root.querySelectorAll('[data-ac-panel]')];
    function loadPanelImages(panel, priority = 'low') {
      panel?.querySelectorAll('img').forEach(img => {
        img.setAttribute('fetchpriority', priority);
        img.setAttribute('loading', 'eager');
      });
    }
    function warmNeighbours() {
      if (navigator.connection?.saveData || galleryPanels.length < 2) return;
      const current = galleryPanels.findIndex(panel => !panel.hidden);
      if (current < 0) return;
      [-1, 1].forEach(step => loadPanelImages(galleryPanels[(current + step + galleryPanels.length) % galleryPanels.length]));
    }
    const firstGalleryImage = galleryPanels.find(panel => !panel.hidden)?.querySelector('img');
    let warmingScheduled = false;
    function scheduleGalleryWarmup() {
      if (warmingScheduled) return;
      warmingScheduled = true;
      if ('requestIdleCallback' in window) window.requestIdleCallback(warmNeighbours, {timeout: 1200});
      else window.setTimeout(warmNeighbours, 250);
    }
    if (firstGalleryImage && !firstGalleryImage.complete) {
      firstGalleryImage.addEventListener('load', scheduleGalleryWarmup, {once: true});
      firstGalleryImage.addEventListener('error', scheduleGalleryWarmup, {once: true});
    } else scheduleGalleryWarmup();
    function showMedia(id, focus = false) {
      root.querySelectorAll('[data-ac-panel]').forEach(panel => {
        panel.hidden = panel.dataset.acPanel !== String(id);
        if (panel.hidden) panel.querySelectorAll('video').forEach(v => v.pause());
        else loadPanelImages(panel, 'high');
      });
      root.querySelectorAll('[data-ac-media]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.acMedia === String(id))));
      warmNeighbours();
      if (focus) {
        const panel = [...root.querySelectorAll('[data-ac-panel]')].find(p => p.dataset.acPanel === String(id));
        panel?.scrollIntoView({block:'center',behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        panel?.querySelector('video')?.focus({preventScroll:true});
      }
    }
    const mediaButtons = [...root.querySelectorAll('[data-ac-media]')];
    mediaButtons.forEach(b => b.addEventListener('click', () => showMedia(b.dataset.acMedia)));
    function moveMedia(step) {
      const current = mediaButtons.findIndex(b => b.getAttribute('aria-pressed') === 'true');
      const next = (current + step + mediaButtons.length) % mediaButtons.length;
      if (mediaButtons[next]) showMedia(mediaButtons[next].dataset.acMedia, true);
    }
    root.querySelector('[data-ac-gallery-prev]')?.addEventListener('click', () => moveMedia(-1));
    root.querySelector('[data-ac-gallery-next]')?.addEventListener('click', () => moveMedia(1));
    root.querySelector('[data-ac-open-video]')?.addEventListener('click', e => showMedia(e.currentTarget.dataset.acOpenVideo, true));
    radios.forEach(radio => radio.addEventListener('change', () => { qty.value = radio.value; qty.dispatchEvent(new Event('change', {bubbles:true})); }));
    function updateTotal() {
      const id = selector ? selector.value : root.querySelector('input[name="id"]').value;
      const v = variants.find(v => String(v.id) === id);
      const count = Number(qty.value);
      if (!v || !Number.isInteger(count) || count < 1 || !qty.checkValidity()) return;
      root.querySelector('[data-ac-price]').innerHTML = money(v.price * count);
      const compare = root.querySelector('[data-ac-compare]');
      compare.hidden = !v.onSale;
      compare.innerHTML = money((v.comparePrice || 0) * count);
      const sale = root.querySelector('[data-ac-sale]');
      if (sale && v.onSale) { sale.hidden = false; sale.textContent = `${v.discountPercent}% OFF`; }
      const saving = root.querySelector('[data-ac-saving]');
      if (saving) { saving.hidden = !v.onSale; saving.textContent = v.onSale ? `You save ${money((v.comparePrice - v.price) * count)}` : ''; }
      const label = root.querySelector('[data-ac-price-label]');
      if (label) label.textContent = `Total for ${count} ${offerName(count)}${itemsPerOffer > 1 ? ` · ${count * itemsPerOffer} ${itemName(count * itemsPerOffer)}` : ''}`;
    }
    ['input', 'change'].forEach(event => qty.addEventListener(event, () => { radios.forEach(r => { r.checked = r.value === qty.value; }); updateTotal(); }));
    function updateVariant() {
      const id = selector ? selector.value : root.querySelector('input[name="id"]').value;
      const v = variants.find(v => String(v.id) === id);
      if (!v) return;
      root.querySelector('[data-ac-price]').innerHTML = v.formatted;
      const compare = root.querySelector('[data-ac-compare]');
      compare.hidden = !v.onSale;
      compare.innerHTML = v.compare;
      const sale = root.querySelector('[data-ac-sale]');
      if (sale && v.onSale) { sale.hidden = false; sale.textContent = `${v.discountPercent}% OFF`; }
      const saving = root.querySelector('[data-ac-saving]');
      if (saving) { saving.hidden = !v.onSale; saving.textContent = v.onSale ? `You save ${money(v.comparePrice - v.price)}` : ''; }
      qty.min = v.min; qty.step = v.step;
      if (v.max == null) qty.removeAttribute('max'); else qty.max = v.max;
      qty.value = v.min;
      const first = v.min, second = v.min + v.step;
      radios[0].value = first; radios[0].checked = true;
      radios[1].value = second; radios[1].checked = false;
      root.querySelector('[data-ac-second-offer]').hidden = v.max != null && second > v.max;
      [['first',first],['second',second]].forEach(([key,count]) => {
        root.querySelector(`[data-ac-${key}-label]`).textContent = offerLabel(count);
        root.querySelector(`[data-ac-${key}-jars]`).textContent = offerSubLabel(count);
        root.querySelector(`[data-ac-${key}-price]`).innerHTML = money(v.price * count);
      });
      add.disabled = !v.available;
      add.textContent = v.available ? 'ADD TO CART' : 'SOLD OUT';
      updateTotal();
      if (v.media && root.querySelector(`[data-ac-panel="${v.media}"]`)) showMedia(v.media);
    }
    selector?.addEventListener('change', () => {
      updateVariant();
      const url = new URL(location.href); url.searchParams.set('variant', selector.value);
      history.replaceState({}, '', url);
    });
    updateTotal();
    // Native Shopify product form owns validation, inventory checks and cart submission.
  }
  function initMotion() {
    document.querySelectorAll('.ac-motion-video').forEach(video => {
      if (video.dataset.motionReady) return;
      video.dataset.motionReady = 'true';
      video.muted = true;
      video.playsInline = true;
      if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches || navigator.connection?.saveData || !('IntersectionObserver' in window)) return;
      let userPaused = false;
      video.addEventListener('pause', () => { if (video.dataset.inView === 'true' && !document.hidden) userPaused = true; });
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          video.dataset.inView = String(entry.isIntersecting);
          if (entry.isIntersecting && !userPaused && !document.hidden) video.play().catch(() => {});
          else video.pause();
        });
      }, {threshold: 0.6});
      observer.observe(video);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) video.pause();
        else if (video.dataset.inView === 'true' && !userPaused) video.play().catch(() => {});
      });
    });
  }
  function initTitleCase() {
    document.querySelectorAll('.ac-eyebrow, .ac-offers legend, .ac-pack-caption, .ac-label').forEach(el => {
      if (el.dataset.titleCaseReady) return;
      el.dataset.titleCaseReady = 'true';
      el.textContent = el.textContent.toLowerCase().replace(/\b\w/g, letter => letter.toUpperCase());
    });
  }
  const initAll = () => { document.querySelectorAll('[data-ac-care]').forEach(init); initTitleCase(); initMotion(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
